var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M2.895 38c-.298-.09-.595-.16-.873-.288C.714 37.097.02 36.056.01 34.61-.01 31.229 0 27.838 0 24.447V5.967c0-2.2 1.398-3.588 3.599-3.588H5.64V3.39c.01 1.993 1.447 3.43 3.45 3.44 2.647.01 5.294 0 7.941 0 2.013 0 3.45-1.447 3.46-3.47V2.38h.585c.763.02 1.537-.03 2.29.07 1.497.208 2.697 1.476 2.736 2.983.06 2.717.02 5.443.02 8.15-.674-.159-1.338-.338-2.012-.456-1.408-.248-2.806-.12-4.184.267-.238.07-.486.11-.724.11-4.461.01-8.932 0-13.393.01a2 2 0 0 0-.546.059 1.096 1.096 0 0 0-.793 1.16c.05.535.486.961 1.031 1 .12.01.248 0 .367 0h10.043c-.308.368-.595.685-.853 1.012-.158.189-.337.387-.426.605-.228.545-.615.625-1.17.625-2.597-.03-5.195-.02-7.792-.01-.902 0-1.458.832-1.071 1.596.228.456.625.624 1.13.624 2.39-.01 4.779 0 7.158 0h.416c-.109.744-.208 1.467-.317 2.23H5.67c-.901 0-1.457.834-1.07 1.597.228.456.625.625 1.13.625 2.38-.01 4.749 0 7.128 0h.337c.248.743.496 1.467.764 2.23H5.7c-.892 0-1.457.803-1.1 1.557.218.476.625.674 1.14.664 2.617-.01 5.245 0 7.862 0 .585 0 1.21-.139 1.735.04.495.168.862.684 1.308 1.01.536.397 1.091.764 1.686 1.17H5.72c-.912 0-1.487.804-1.12 1.577.218.466.605.654 1.11.654h14.544c1.001 0 1.338-.287 1.487-1.279 1.487.12 2.945-.05 4.412-.604v.763c-.01.902.06 1.814-.06 2.706-.188 1.497-1.21 2.499-2.706 2.816-.05.01-.09.04-.139.06H2.895Zm10.171-26.718h7.376c.526 0 .922-.199 1.13-.684.338-.764-.227-1.547-1.12-1.547H5.621c-.505 0-.882.228-1.08.694-.318.753.237 1.527 1.11 1.527 2.478.01 4.947.01 7.415.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M35.403 38c-.665-.168-1.15-.575-1.616-1.05-.903-.933-1.844-1.825-2.747-2.757-1.2-1.249-.644-3.281 1.022-3.707.723-.189 1.427-.07 1.972.446 1.16 1.11 2.3 2.24 3.4 3.41.269.278.378.714.556 1.07v.744c-.258.982-.872 1.596-1.854 1.854-.238-.01-.486-.01-.733-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M27.075 28.641c-3.51 2.479-7.941 1.557-10.261-1.407a7.427 7.427 0 0 1 .565-9.786c2.598-2.646 6.771-2.944 9.745-.723 3.004 2.25 4.065 6.751 1.537 10.34.555.555 1.12 1.11 1.527 1.507-.545.535-1.061 1.05-1.616 1.596-.387-.387-.942-.962-1.497-1.527Zm-5.443-5.482c-.06-.03-.09-.04-.109-.05-.377-.376-.753-.753-1.13-1.12-.545-.545-1.2-.585-1.676-.119-.465.456-.426 1.15.09 1.676.634.644 1.279 1.279 1.913 1.913.555.545 1.18.555 1.725.01.466-.456.932-.922 1.388-1.388.902-.902 1.804-1.794 2.697-2.707.644-.664.366-1.695-.506-1.893-.436-.1-.793.05-1.11.367-1.071 1.1-2.172 2.2-3.282 3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M13.027 4.6H9.13c-.813 0-1.26-.446-1.26-1.259 0-.605-.01-1.21 0-1.814C7.882.634 8.507.01 9.389 0h7.347c.882 0 1.507.634 1.517 1.527.01.634.01 1.259 0 1.893-.01.724-.466 1.18-1.19 1.18-1.339.01-2.687 0-4.035 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 20.567,
    x2: -3.959,
    y1: 8.163,
    y2: 21.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 36.366,
    x2: 30.388,
    y1: 31.637,
    y2: 36.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 26.99,
    x2: 15.252,
    y1: 17.665,
    y2: 26.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 16.036,
    x2: 12.68,
    y1: 0.748,
    y2: 6.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h38v38H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/track.5bcf5fcf6379cf9b08e95a0a570d172b.svg";
export { ForwardRef as ReactComponent };